RivalIQ.module('universal.data', function (data, App, Backbone, Marionette, $, _) {

    'use strict';

    const MetricCacheLayer = RivalIQ.data.CacheLayer.extend({
        name: 'UniversalMetricCacheLayer',
        cacheKeys: [
            '_universalApiCacheKey'
        ],
        loadData: function (attributes) {
            return App.universal.fetch(null, [new RivalIQ.models.MetricDefinition(attributes)]).then(_.head);
        }
    });

    data.Metric = new MetricCacheLayer();

});
